import { render, staticRenderFns } from "./BuyerKeys.vue?vue&type=template&id=63138a80&scoped=true&"
import script from "./BuyerKeys.vue?vue&type=script&lang=js&"
export * from "./BuyerKeys.vue?vue&type=script&lang=js&"
import style0 from "./BuyerKeys.vue?vue&type=style&index=0&id=63138a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63138a80",
  null
  
)

export default component.exports